/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { EnergyUsageCollectionStepResponse } from '../models/EnergyUsageCollectionStepResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class EnergySourcesRoutesRepository {
  /**
   * Get Energy Usage Collection Steps
   * Lists all energy_usage_collection_steps.
   * @returns any Successful Response
   * @throws ApiError
   */
  public static energySourcesRoutesGetEnergyUsageCollectionSteps({
    energySourceId,
    authorization,
  }: {
    energySourceId: any,
    authorization?: string,
  }): CancelablePromise<(Array<EnergyUsageCollectionStepResponse> | null)> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/energy-sources/{energy_source_id}/energy-usage-collection-steps',
      path: {
        'energy_source_id': energySourceId,
      },
      headers: {
        'authorization': authorization,
      },
      errors: {
        404: `Not Found`,
        422: `Validation Error`,
      },
    });
  }
}
